<template>
  <v-dialog v-model="show" fullscreen transition="dialog-bottom-transition" @keydown.esc="show = false">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon @click.native="show = false" dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Search</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
        </v-toolbar-items>
      </v-toolbar>
      <v-layout row wrap>
        <v-flex lg2 xs12>
          <v-container fluid class="pa-0 mt-2">
            <v-flex xs12>
              <v-text-field label="Search" v-model="search" single-line full-width hide-details></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-divider></v-divider>
            </v-flex>
          </v-container>
          <v-list subheader v-if="!isEmpty">
            <v-subheader>Categories</v-subheader>
            <v-list-item v-for="item in filteredItems" v-bind:key="item.id" @click="selectItem(item.id)">
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list subheader v-else>
            <v-subheader>Categories</v-subheader>
            <v-list-item>
              <v-list-item-content>
                No category found
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex lg10 xs12>
          <v-card-text>
            <component :is="selectedComponent"></component>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { SEARCH_CLOSE, SEARCH_CATEGORY_SELECT } from '@/store/types'
import SearchList from './index'
import Empty from './Empty'

export default {
  data() {
    return {
      show: false,
      search: '',
      items: SearchList
    }
  },
  computed: {
    globalShow() {
      return this.$store.state.search.show
    },
    filteredItems() {
      if (this.search && this.search !== '') {
        const result = this.items.filter(item => {
          return item.text.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        })
        return result
      } else {
        return this.items
      }
    },
    isEmpty() {
      if (this.filteredItems.length > 0) {
        return false
      } else {
        return true
      }
    },
    selectedComponent() {
      const active = this.$store.state.search.active
      if (active) {
        const findItem = this.items.find(a => a.id === active)
        if (findItem) {
          return findItem.component
        } else {
          return Empty
        }
      } else {
        return Empty
      }
    }
  },
  watch: {
    'show': function (value) {
      if (!value) {
        this.$store.commit(SEARCH_CLOSE)
      }
    },
    'globalShow': function (value) {
      if (value) {
        this.show = true
      }
    }
  },
  methods: {
    selectItem(id) {
      this.$store.commit(SEARCH_CATEGORY_SELECT, id)
    }
  },
  mounted() {
    // Sort the list to alphabetical order
    this.items.sort(function (a, b) { return (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0) })
  }
}
</script>

<style lang="scss">

</style>
